import React from 'react';
import { Play, Pause, CheckCircle, Square, Volume2, VolumeX, Clock } from 'lucide-react';

export default function TimerControls({
    isStructuredFitness, currentWod, isRunning, setIsRunning,
    soundEnabled, setSoundEnabled, rounds, setRounds,
    currentIntervalRound, skipToNextPhase, setTime, setRestTime
}) {
    if (isStructuredFitness) return null;

    const formatStr = String(currentWod?.format || '').toUpperCase();
    const typeStr = String(currentWod?.type || '').toUpperCase();
    const titleStr = String(currentWod?.title || '').toUpperCase();

    const combinedString = `${formatStr} ${typeStr} ${titleStr}`;
    const isCardioUI = typeStr.includes('CARDIO') || titleStr.includes('CARDIO');

    const isRounds = !isCardioUI && (combinedString.includes('EMOM') || combinedString.includes('TABATA'));
    const isAmrap = !isCardioUI && !isRounds && combinedString.includes('AMRAP');
    const isStopwatchOrCountdown = isCardioUI || (!isAmrap && !isRounds);

    const btnBase = "flex items-center justify-center rounded-full shadow-2xl transition-transform hover:scale-105 shrink-0 text-white";
    const btnLarge = `${btnBase} w-20 h-20 sm:w-24 sm:h-24`;
    const btnSmall = `${btnBase} w-16 h-16 sm:w-20 sm:h-20`;
    const volumeBtnClass = `${btnSmall} ${soundEnabled ? 'bg-cyan-600' : 'bg-zinc-600'}`;

    return (
        <div className="flex flex-col items-center w-full mb-8">
            {isAmrap && (
                <div className="flex flex-row items-center justify-center gap-4 sm:gap-8 w-full mt-2">
                    <button onClick={() => setIsRunning(!isRunning)} className={`${btnLarge} ${isRunning ? 'bg-yellow-600' : 'bg-green-600'}`}>{isRunning ? <Pause size={40} /> : <Play size={40} fill="currentColor" className="ml-2" />}</button>
                    <button onClick={() => setSoundEnabled(!soundEnabled)} className={volumeBtnClass}>{soundEnabled ? <Volume2 size={32} /> : <VolumeX size={32} />}</button>
                    <button onClick={() => setRounds(r => r + 1)} className={`${btnSmall} bg-blue-600 relative`}>
                        <CheckCircle size={32} className="text-white" />
                        <span className="absolute -top-2 -right-2 bg-orange-500 text-white font-black w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center text-lg sm:text-xl border-2 border-white shadow-md">{rounds}</span>
                    </button>
                </div>
            )}
            {isRounds && (
                <div className="flex flex-col items-center gap-4 w-full">
                    <div className="text-xl font-bold text-gray-400 uppercase tracking-widest mb-2 focus-round-info">Ronde {currentIntervalRound} {combinedString.includes('TABATA') && `/ 8`}</div>
                    <div className="flex flex-row items-center justify-center gap-4 sm:gap-8 w-full mt-2">
                        <button onClick={() => setIsRunning(!isRunning)} className={`${btnLarge} ${isRunning ? 'bg-yellow-600' : 'bg-green-600'}`}>{isRunning ? <Pause size={40} /> : <Play size={40} fill="currentColor" className="ml-2" />}</button>
                        <button onClick={() => setSoundEnabled(!soundEnabled)} className={volumeBtnClass}>{soundEnabled ? <Volume2 size={32} /> : <VolumeX size={32} />}</button>
                        <button onClick={skipToNextPhase} className={`${btnSmall} bg-purple-600 hover:bg-purple-500`}><CheckCircle size={36} /></button>
                    </div>
                </div>
            )}
            {isStopwatchOrCountdown && (
                <div className="flex flex-col items-center gap-4 w-full">
                    <div className="flex flex-row items-center justify-center gap-4 sm:gap-8 w-full mt-2">
                        <button onClick={() => setIsRunning(!isRunning)} className={`${btnLarge} ${isRunning ? 'bg-yellow-600' : 'bg-green-600'}`}>{isRunning ? <Pause size={40} /> : <Play size={40} fill="currentColor" className="ml-2" />}</button>
                        <button onClick={() => setSoundEnabled(!soundEnabled)} className={volumeBtnClass}>{soundEnabled ? <Volume2 size={32} /> : <VolumeX size={32} />}</button>
                        <button onClick={() => {setIsRunning(false); setTime(0);}} className={`${btnSmall} bg-red-600 hover:bg-red-500`}><Square size={36} fill="currentColor" /></button>
                    </div>
                    <div className="flex flex-row flex-wrap justify-center gap-3 mt-6 w-full">
                        <button onClick={() => setRestTime(60)} className="px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white border border-blue-500 rounded-full font-black text-sm flex items-center gap-2 transition-all shadow-md">
                            <Clock size={18}/> Rust (60s)
                        </button>
                        <button onClick={() => setRestTime(120)} className="px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white border border-blue-500 rounded-full font-black text-sm flex items-center gap-2 transition-all shadow-md">
                            <Clock size={18}/> Rust (2m)
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
